import React from 'react';
import { Box, Flex } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { boxStyles } from '../../constants/styles';

interface Props {
  testId?: string;
  cardsCount?: number;
}

const renderBoxContent = () => {
  const marginRight = '0';
  const height = '14px';
  const marginBottom = '8px';

  return (
    <Box padding="space.200" xcss={boxStyles}>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="70%" marginRight={marginRight} marginBottom={marginBottom} height={height} />
      </SkeletonLoaderWrapper>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="70%" marginRight={marginRight} height="28px" marginBottom="12px" />
      </SkeletonLoaderWrapper>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="85%" marginRight={marginRight} marginBottom={marginBottom} height={height} />
      </SkeletonLoaderWrapper>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="60%" marginRight={marginRight} marginBottom="0" height={height} />
      </SkeletonLoaderWrapper>
    </Box>
  );
};

/**
 * EntitlementCardsLoader component is used to render a one or more cards seen in the entitlement page.
 * @param testId - testId for the component
 * @param cardsCount - number of cards to render in one row
 */
export const EntitlementCardsLoader = ({ testId = 'entitlement-cards-loader', cardsCount = 5 }: Props) => {
  const renderContentLoaders = () => {
    return (
      <Flex justifyContent="space-between" gap="space.300">
        {Array.from({ length: cardsCount }).map((_) => renderBoxContent())}
      </Flex>
    );
  };

  return <div data-testid={testId}>{renderContentLoaders()}</div>;
};
